module.exports = __webpack_public_path__ + "static/Artboard-10-d7f23266bac9a3b78d5848a29aed3659.png";